// v0.3.0 — Company (yard) switcher shown in the sidebar header.
//
// When the user belongs to a single company this renders just that company's
// name (no control) — so for the current single-company world it is invisible
// beyond showing "Sega Tech Solution". When they belong to 2+, it becomes a
// dropdown that switches the active company (which hard-reloads the app so
// every page re-queries the chosen company cleanly).

import { useYards, switchYard } from '@/lib/yardStore';
import { Building2, ChevronDown } from 'lucide-react';

export default function YardSwitcher() {
  const { yards, activeId, active, loading } = useYards();

  // Single company (or still loading the list): plain label, no control.
  if (yards.length <= 1) {
    return (
      <div className="truncate text-xs text-slate-500">
        {active?.name ?? (loading ? '…' : yards[0]?.name ?? 'Sega Tech Solution')}
      </div>
    );
  }

  return (
    <div className="relative mt-0.5">
      <Building2 className="pointer-events-none absolute left-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
      <select
        aria-label="Active company"
        value={activeId ?? ''}
        onChange={(e) => switchYard(Number(e.target.value))}
        className="w-full appearance-none rounded-md border border-slate-300 bg-white py-1.5 pl-7 pr-7 text-xs font-medium text-slate-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
      >
        {yards.map((y) => (
          <option key={y.yard_id} value={y.yard_id}>
            {y.name}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
    </div>
  );
}
